//Master Status
//1	Active
//3	Terminated
//4	Pending for Activation

const masterStatus = {
  1: [
    {
      id: 1,
      name: "Active"
    },
    {
      id: 2,
      name: "Suspended"
    },
    {
      id: 3,
      name: "Terminated"
    }
  ],
  2: [
    {
      id: 2,
      name: "Suspended"
    },
    {
      id: 1,
      name: "Active"
    },

    {
      id: 3,
      name: "Terminated"
    }
  ],
  3: [
    {
      id: 3,
      name: "Terminated"
    }
  ],
  4: [
    {
      id: 4,
      name: "Pending for Activation"
    },
    {
      id: 1,
      name: "Active"
    }
  ]
};
export const getMasterStatus = function(initialStatus) {
  if (masterStatus.hasOwnProperty(initialStatus)) {
    return masterStatus[initialStatus];
  } else {
    return [];
  }
};

//User
// 1	Active
// 2	Suspended
// 3	Terminated
// 4	Pending for Activation

const userStatus = {
  1: [
    {
      id: 1,
      name: "Active"
    },
    {
      id: 2,
      name: "Suspended"
    },
    {
      id: 3,
      name: "Terminated"
    }
  ],
  2: [
    {
      id: 2,
      name: "Suspended"
    },
    {
      id: 1,
      name: "Active"
    },

    {
      id: 3,
      name: "Terminated"
    }
  ],
  3: [
    {
      id: 3,
      name: "Terminated"
    }
  ],
  4: [
    {
      id: 4,
      name: "Pending for Activation"
    },

    {
      id: 5,
      name: "Ready for Activation"
    }
  ],
  5: [{ id: 5, name: "Ready for Activation" },
      {
      id: 2,
      name: "Suspended"
      },
      {
        id: 3,
        name: "Terminated"
      }

  ]
};
export const getUserStatus = function(initialStatus) {
  if (userStatus.hasOwnProperty(initialStatus)) {
    return userStatus[initialStatus];
  } else {
    return [];
  }
};

const RoleStatus = {
  2: [
    {
      id: 2,
      name: "Active"
    },
    {
      id: 3,
      name: "Suspended"
    },
    {
      id: 4,
      name: "Terminated"
    }
  ],
  3: [
    {
      id: 2,
      name: "Active"
    },
    {
      id: 3,
      name: "Suspended"
    },

    {
      id: 4,
      name: "Terminated"
    }
  ],
  4: [
    {
      id: 4,
      name: "Terminated"
    }
  ],
  1: [
    {
      id: 1,
      name: "Pending for Activation"
    },

    {
      id: 2,
      name: "Active"
    },
    {
      id: 4,
      name: "Terminated"
    }
  ]
};

export const getRoleStatus = function(initialStatus) {
  if (RoleStatus.hasOwnProperty(initialStatus)) {
    return RoleStatus[initialStatus];
  } else {
    return [];
  }
};